import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators/catchError';
import { ServicosService } from '@service/core/servicos.service';
import { Router } from '@angular/router';
import { AtoNormativoService } from '@service/ato-normativo/ato-normativo.service';
import * as $ from 'jquery';

@Injectable()
export class AuthService {

  private static CLIENT_ID = 'aWRhcHBjbGllbnRlNzA5MTIyMDE';
  private static CLIENT_SECRET = 'c2VjcmV0YXBwY2xpZW50ZTcwOTEyMjAxNg';

  public access_token: any;
  public token_type: any;
  public expires_in: any;
  public refresh_token: any;
  public usuario: any;
  public menus: any;
  public alteracaoSenha = { senhaAtual: null, login: null };
  public filtro: any;
  private headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  };

  constructor(public router: Router,
    public http: HttpClient,
    public servicos: ServicosService) {
    this.createSessao();
  }

  private createSessao() {
    this.access_token = localStorage.getItem('access_token');
    this.token_type = localStorage.getItem('token_type');
    this.expires_in = localStorage.getItem('expires_in');
    this.refresh_token = localStorage.getItem('refresh_token');
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.menus = JSON.parse(localStorage.getItem('menus'));
  }

  login(login: string, senha: string, lembrar: boolean = false) {
    const urlAutenticacaoSistema = this.servicos.urls.urlAutenticacaoSistema
      .replace('{login}', login).replace('{senha}', encodeURIComponent(senha));
    return this.http.post(urlAutenticacaoSistema, null, this.headers).pipe(
      tap(res => {
        this.configurarSessao(res, lembrar);
      })
      , catchError(err => {
        console.log(err);
        return Observable.throw(err);
      }));
  }

  loginSso(endpoint: string, token: string, username: string) {
    $.ajax({
      url: endpoint,
      type: 'POST',
      headers: {
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: JSON.stringify({ informacoes: username }),
      success: function(response) {             
        // token
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('token_type', response.token_type);
        localStorage.setItem('expires_in', response.expires_in);
        localStorage.setItem('refresh_token', response.refresh_token);
        // session
        localStorage.setItem('usuario', JSON.stringify(response.usuario));
        localStorage.setItem('menus', JSON.stringify(response.menus));  
        // redirect
        window.location.assign('/#/dashboard-simples'); 
        window.location.reload();                     
      },
      error: function(error) {        
        localStorage.clear();
        localStorage.setItem('flagSso', 'true');
        window.location.assign('/#/logout');         
        window.location.reload();        
      }
    });
  }

  refreshToken() {
    const urlRefreshTokenSistema = this.servicos.urls.urlAutenticacaoSistema +
      `/oauth2/token?grant_type=refresh_token&client_id=${AuthService.CLIENT_ID}` +
      `&client_secret=${AuthService.CLIENT_SECRET}&refresh_token=${this.refresh_token}`;
    return this.http.post(urlRefreshTokenSistema, null, this.headers).pipe(
      tap(res => {
        this.configurarSessao(res);
      })
      , catchError(err => {
        if (err.error.status === 403) {
          this.router.navigate(['/login']);
        } else {
          console.log(err);
          return Observable.throw(err);
        }
      }));
  }

  alterarSenha(request: any, login: string) {
    const urlAlteracaoSenha = this.servicos.urls.urlAlteracaoSenha.replace('{login}', login);
    return this.http.put(urlAlteracaoSenha, request)
      .pipe(
        catchError(err => {
          console.log(err);
          return Observable.throw(err);
        }));
  }

  alterarImagem(foto: any) {
    const urlAlteracaoFoto = this.servicos.urls.urlPesquisaUsuarios + this.usuario.id + '/foto';
    return this.http.put(urlAlteracaoFoto, foto)
      .pipe(
        catchError(err => {
          console.log(err);
          return Observable.throw(err);
        }));
  }

  recuperarSenha(login: string) {
    const urlRecuperacaoSenha = this.servicos.urls.urlRecuperacaoSenha.replace('{login}', login);
    return this.http.post(urlRecuperacaoSenha, null, this.headers)
      .pipe(
        catchError(err => {
          return Observable.throw(err);
        }));
  }

  configurarSessao(sessao: any, lembrar: boolean = false) {
    this.access_token = sessao.access_token;
    this.token_type = sessao.token_type;
    this.expires_in = sessao.expires_in;
    this.refresh_token = sessao.refresh_token;
    this.usuario = sessao.usuario;
    this.menus = sessao.menus;
    if (lembrar) {
      this.saveSession(sessao, );
    }
  }

  saveSession(sessao: any) {
    localStorage.setItem('access_token', sessao.access_token);
    localStorage.setItem('token_type', sessao.token_type);
    localStorage.setItem('expires_in', sessao.expires_in);
    localStorage.setItem('refresh_token', sessao.refresh_token);
    localStorage.setItem('usuario', JSON.stringify(sessao.usuario));
    localStorage.setItem('menus', JSON.stringify(sessao.menus));
  }

  logout() {
    localStorage.clear();
    window.location.assign('/#/logout');          
    //window.location.reload();   
  }

}



// WEBPACK FOOTER //
// ./src/app/service/core/auth.service.ts